import React, { useEffect, useRef, useState } from 'react';
import { Script } from 'gatsby';
import useMatchMedia from 'utils/hooks/useMatchMedia';
import theme from 'mui/base/theme/index';

import mapBoundsHandler from './utils/mapBoundsHandler';
import initWoosmapMarkers from './Marker';
import conf, { mergeDefaults } from './DS_MapConfig';

import { StyledMap } from './DS_MapStyles';

const DS_Map = ({
  locations,
  selectedLocation,
  setSelectedLocation,
  setIsMapLoaded,
  metaData,
  options = {},
  showTimeSlots,
}) => {
  const [map, setMap] = useState(null);
  const [mapMarkers, setMapMarkers] = useState(null);
  const mapContainerRef = useRef(null);
  const desktopBreakpoint = theme.breakpoints.values.lg;
  const isDesktop = useMatchMedia(`(min-width: ${desktopBreakpoint}em)`);
  const opts = mergeDefaults(options, conf);

  // if the map is on full width without any container being displayed on it i.e. locations list
  opts.mapPaddings = opts.fullView
    ? {
        mobile: { left: 50, right: 50, top: 125, bottom: 50 },
        full: { left: 50, right: 50, top: 125, bottom: 50 },
      }
    : opts.mapPaddings;

  const onMarkerClick = async location => {
    setSelectedLocation(location);
  };

  useEffect(() => {
    if (!map || !locations || !Array.isArray(locations)) return;
    initWoosmapMarkers(
      map,
      locations,
      mapMarkers,
      setMapMarkers,
      metaData,
      onMarkerClick,
      opts,
      selectedLocation,
      showTimeSlots,
      setSelectedLocation,
    );
  }, [locations, map]);

  useEffect(() => {
    if (!mapMarkers) return;

    mapBoundsHandler(
      map,
      locations,
      mapMarkers,
      isDesktop ? opts.mapPaddings.full : opts.mapPaddings.mobile,
      opts.woosmapConfig.zoom,
    );

    setTimeout(() => setIsMapLoaded(true), 1000);
  }, [locations, mapMarkers, isDesktop]);

  const initMap = () => {
    try {
      const mapWoosmap = new window.woosmap.map.Map(mapContainerRef.current, opts.woosmapConfig);
      setMap(mapWoosmap);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Script
        src={conf.url.mapJs}
        onLoad={() => initMap()}
        onError={error => {
          console.log('Woosmap loading error.', error);
        }}
      />
      <StyledMap ref={mapContainerRef} zoomControls={opts.zoomControls} fullView={opts.fullView} />
    </>
  );
};

export default React.memo(DS_Map);
